"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Group = require("./Group");

var _Group2 = _interopRequireDefault(_Group);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Group2.default;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wel-ui/component-group/lib/index.js
// module id = 324
// module chunks = 0